import { Dropdown } from "react-bootstrap";
import StyledToggle from "../../../../boundarySelection/ViewTools/StyledToggle";
import useGetCensusParams from "./GetCensusParams";
import styled from "styled-components";
import { useState } from "react";
import { CensusCategory } from "../../../../../types/Census/CensusCategory";
import CensusUrlKeys from "../../../../../constant/CensusUrlKeys";

interface ColumnDropdownProps {
  categories: CensusCategory[];
  loading: boolean;
  showValidationError: boolean;
}

const CensusDropdown = styled(Dropdown)`
  width: 650px;
`;

const CensusDropdownMenu = styled(Dropdown.Menu)`
  font-size: 12px;
  max-height: 500px;
  width: 100%;
  overflow-y: auto;
`;

const SearchInput = styled.input`
  border: none;
  background: transparent;
  outline: none;
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: inherit;
`;

const ColumnDropdown = ({
  categories,
  loading,
  showValidationError,
}: ColumnDropdownProps) => {
  const { categoryId, columnId, handleSelect } = useGetCensusParams();
  const [searchText, setSearchText] = useState("");
  const [show, setShow] = useState(false);

  const handleChange = (selectedColumn: string | null) => {
    handleSelect(CensusUrlKeys.COLUMN, Number(selectedColumn));
    setSearchText("");
    setShow(false);
  };

  const handleToggle = (nextShow: boolean) => {
    setShow(nextShow);
    if (!nextShow) setSearchText("");
  };

  const selectedCategory = categories.find((c) => c.categoryId === categoryId);

  const columns = selectedCategory?.columns ?? [];

  const cleanName = (name: string) => {
    return name.replace(/\(.*?\)/g, "").trim();
  };

  const isInvalid = showValidationError && columnId === null;

  const selectedColumnName = cleanName(
    columns.find((c) => c.columnId === columnId)?.name ?? "",
  );

  const inputValue = show ? searchText : selectedColumnName;

  const filteredColumns =
    searchText ?
      columns.filter((c) =>
        cleanName(c.name).toLowerCase().includes(searchText.toLowerCase()),
      )
    : columns;

  return (
    <CensusDropdown show={show} onSelect={handleChange} onToggle={handleToggle}>
      <StyledToggle
        disabled={columns.length === 0 || loading}
        style={{ width: "285px", fontSize: "10px" }}
        $isInvalid={isInvalid}
        className="view-tools-dropdown fs-6 text-black"
        size="lg"
      >
        <SearchInput
          id="census-column-search"
          placeholder={loading ? "Loading..." : "Search Columns...."}
          value={inputValue}
          title={selectedColumnName || undefined}
          disabled={columns.length === 0 || loading}
          onChange={(e) => {
            setSearchText(e.target.value);
            setShow(true);
          }}
          onClick={(e) => {
            e.stopPropagation();
            setShow(true);
          }}
        />
      </StyledToggle>

      <CensusDropdownMenu>
        {filteredColumns.map((y) => {
          const name = cleanName(y.name);
          return (
            <Dropdown.Item
              key={y.columnId}
              eventKey={String(y.columnId)}
              active={y.columnId === columnId}
              disabled={!y.haveData}
            >
              {name}
            </Dropdown.Item>
          );
        })}
      </CensusDropdownMenu>
    </CensusDropdown>
  );
};

export default ColumnDropdown;
